module.exports = __webpack_public_path__ + "img/IMAGE4.4f37dc93.jpg";